// Update this with your actual Etsy shop URL when ready
export const ETSY_SHOP_URL = "https://www.etsy.com/shop/YourShopName";
export const CONTACT_EMAIL = "info@megadish.co.uk";
